import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Connexion réussie !');
      navigate('/');
    } catch (error) {
      toast.error('Identifiants incorrects');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/162639/digger-machine-machinery-construction-162639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)' }}
      />
      
      <Card className="w-full max-w-md p-8 bg-white shadow-xl border-slate-200 rounded-sm relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_granulat-control/artifacts/k87nilu3_10.png" 
            alt="AGRABAT Logo" 
            className="h-16 object-contain"
          />
        </div>

        <h1 className="text-2xl font-bold text-[#1B3268] text-center mb-6" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          Connexion
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-slate-700 font-medium">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
              className="mt-1.5 h-10 border-slate-300 focus:border-[#1B3268] focus:ring-1 focus:ring-[#1B3268] rounded-sm"
            />
          </div>

          <div>
            <Label htmlFor="password" className="text-slate-700 font-medium">Mot de passe</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
              className="mt-1.5 h-10 border-slate-300 focus:border-[#1B3268] focus:ring-1 focus:ring-[#1B3268] rounded-sm"
            />
          </div>

          <Button 
            type="submit" 
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-[#1B3268] hover:bg-[#152a55] text-white font-medium rounded-sm shadow-sm transition-all active:scale-95 h-11"
          >
            {loading ? 'Chargement...' : 'Se connecter'}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-slate-500" data-testid="restricted-access-note">
          Accès réservé. Contactez l'administrateur pour obtenir un compte.
        </p>
      </Card>
    </div>
  );
};

export default LoginPage;
